import * as Constants from "../common/Constants";
import sha256 from "crypto-js/sha256";

const initialState = {
    notifications: [],
    lastId: 1
};


export default function notificationReducer(state = initialState, action) {
    const newState = { ...state };
    
    switch (action.type) {
        case Constants.SHOW_NOTIFICATION:
            var options = action.payload;
            options.show = true;
            options.type = options.type || "success";
            options.place = options.place || "br";
            
            var key = ""+sha256(JSON.stringify(options));
            if (newState.notifications.some(a => a.key === key)) {
                return state;
            }
            options.key = key;
            options.id = newState.lastId++;
            var noti = [...newState.notifications, options];
            newState.notifications = noti;
            return newState;

        case Constants.HIDE_NOTIFICATION:
            
            var list = [...newState.notifications];
            var notif = list.find(a => a.id === action.id);
            var ix = list.indexOf(notif);
            notif = { ...notif };
            notif.show = false;
            list[ix] = notif;
            newState.notifications = list;
            return newState;

        case Constants.REMOVE_NOTIFICATION:
            var idx = newState.notifications.indexOf(newState.notifications.find(a => a.id === action.id));
            var notifs = [...newState.notifications];
            notifs.splice(idx, 1);
            newState.notifications = notifs;
            return newState;

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/NotificationReducer.js